import React, { Component } from 'react';
import { API } from "src/Services/Api/Api";

export class TableauViz extends Component {
    API;
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <tableau-viz id="tableauViz"
                    src={this.props.src}
                    token={this.props.token}
                    toolbar="top"
                    height="80vh"
                    width="100%"
                    contentUrl={this.props.contentUrl}>
                </tableau-viz>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Reporting/Tableau/TableauViz.js